import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/auth-guard';
import { FacilityDashboardComponent } from './facility-dashboard/facility-dashboard.component';
import { FacilityRuleComponent } from './facility-rule/facility-rule.component';

const routes: Routes = [
    { path: 'facility', component: FacilityDashboardComponent, canActivate: [AuthGuard] },
    { path: 'addfacility', component: FacilityRuleComponent, canActivate: [AuthGuard] }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FacilityRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/facility/facility-routing.module.ts